module.exports = __webpack_public_path__ + "img/warning.061f6bd0.png";